<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NSpM3F/tc-custom/9780374715564.jpg?1731787005443" alt="This image is the cover for the book Pagan Light"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pagan Light
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A <i>New York Times Book Review </i>Editors' Choice</b><br/><b><br/>"<i>Pagan Light</i> is mesmerizing. Every detail is compelling. I felt I was reading a family history of a family far more interesting than mine." --Edmund White, author of <i>Our Young Man</i></b><br/><b><br/>A rich, intimate embrace of Capri, which was a magnet for artistic renegades and a place of erotic refuge</b><br/><br/>Isolated and arrestingly beautiful, the island of Capri has been a refuge for renegade artists and writers fleeing the strictures of conventional society from the time of Augustus, who bought the island in 29 BC after defeating Antony and Cleopatra, to the early twentieth century, when the poet and novelist Jacques d’Adelswärd-Fersen was in exile there after being charged with corrupting minors, to the 1960s, when Truman Capote spent time on the island. We also meet the Marquis de Sade, Goethe, Mark Twain, Oscar Wilde, Compton Mackenzie, Rilke, Lenin, and Gorky, among other astonishingly vivid characters. <br/><br/> Grounded in a deep intimacy with Capri and full of captivating anecdotes, Jamie James’s<i> Pagan Light</i> tells how a tiny island served as a wildly permissive haven for people—queer, criminal, sick, marginalized, and simply crazy—who had nowhere else to go.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jamie James
      </h2>
      
      <p class="authorDescription body article"><B>Jamie James</B> is the author of several books of nonfiction, including <I>The Glamour of Strangeness</I>. He has contributed to <I>The New York Times</I>, <I>The New Yorker</I>, <I>The Wall Street Journal</I>, <I>Vanity Fair</I>, and <I>The Atlantic</I>, among other publications, and he previously served as the American arts correspondent for <I>The Times</I> (London). He has lived in Indonesia since 1999 and is a recipient of a Guggenheim Foundation Grant.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f2864a0